import { render, staticRenderFns } from "./OrderExport.vue?vue&type=template&id=506c6651&scoped=true"
import script from "./OrderExport.vue?vue&type=script&lang=js"
export * from "./OrderExport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_e639414b8f28593ae71b2a471b1115a5/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "506c6651",
  null
  
)

export default component.exports